// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;In peace I will lie down and sleep,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for it is you Lord, only, who make me dwell in safety.<br> </p> </div></div>";
// Exports
module.exports = code;